import React, { useEffect } from 'react';
import { useParams, useNavigate, useLocation, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DEFAULT_UI_LANGUAGE, isSupportedUiLanguage, normalizeUiLanguage } from '../../i18n/language';
import { logAdmin } from '../../utils/adminDebug';

const LanguageRouteWrapper: React.FC = () => {
  const { lang } = useParams<{ lang: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const pathWithoutLang = location.pathname.replace(/^\/[a-z]{2}/, '') || '/';
    const suffix = `${pathWithoutLang}${location.search}`;

    logAdmin('language route', {
      lang,
      pathname: location.pathname,
      pathWithoutLang,
      i18nLanguage: i18n.language,
    });

    if (!lang || !isSupportedUiLanguage(lang)) {
      logAdmin('language redirect', { from: lang, to: DEFAULT_UI_LANGUAGE, suffix });
      navigate(`/${DEFAULT_UI_LANGUAGE}${suffix}`, { replace: true });
      return;
    }

    const targetLang = normalizeUiLanguage(lang);
    if (i18n.language !== targetLang) {
      i18n.changeLanguage(targetLang).catch((err) => {
        logAdmin('i18n changeLanguage failed', { targetLang, message: String(err) });
      });
      localStorage.setItem('i18nextLng', targetLang);
    }
  }, [lang, location.pathname, location.search, navigate, i18n]);

  return <Outlet />;
};

export default LanguageRouteWrapper;
